import { useEffect, useState } from 'react';
import SlickSlider from 'react-slick';
import ReactDOM from 'react-dom';
import Image from 'library/components/image';
import {
  Icon,
  ActionIcon,
  ImageContainer,
  Slide,
  GalleryContainer, Overlay, MainSlide, MainSliderContainer,
  NavSliderContainer,
} from './styles';

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <Icon className="icon-arrow-right" />
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <Icon className="icon-arrow-left" />
    </div>
  );
};

const navSettings = {
  dots: false,
  infinite: false,
  speed: 400,
  slidesToShow: 10,
  centerMode: true,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const mainImagesSettings = {
  dots: false,
  infinite: false,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  variableWidth: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const renderMainSlide = (image) => (
  <MainSlide key={image.id}>
    <ImageContainer>
      <Image isThumb={false} name={image.url} id={image.id} source={image} isNew={image.isNew} />
    </ImageContainer>
  </MainSlide>
);

const renderSlide = (image) => (
  <Slide key={image.id}>
    <ImageContainer>
      <Image name={image.url} id={image.id} source={image} isNew={image.isNew} />
    </ImageContainer>
  </Slide>
);

const Gallery = ({ data, openedImageId, onClose }) => {
  const domNode = document.body;
  let sliderMain = null;
  let sliderNav = null;

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [fade, setFade] = useState(false);

  const galleryClose = () => {
    setFade(false);

    setTimeout(() => {
      onClose();
    }, 300);
  };

  useEffect(() => {
    sliderMain.slickGoTo(data.findIndex(({ id }) => openedImageId === id));

    setNav1(sliderMain);
    setNav2(sliderNav);

    setFade(true);
  }, []);

  return (
    ReactDOM.createPortal(
      <GalleryContainer style={{ opacity: fade ? 1 : 0 }}>
        <Overlay>
          <ActionIcon onClick={galleryClose}>
            <Icon className="icon-close-1" />
          </ActionIcon>
          <MainSliderContainer count={data?.length}>
            <SlickSlider
              asNavFor={nav2}
              ref={(slider) => { sliderMain = slider; }}
              {...mainImagesSettings}
            >
              {data.map(renderMainSlide)}
            </SlickSlider>
          </MainSliderContainer>
          <NavSliderContainer>
            <SlickSlider
              asNavFor={nav1}
              ref={(slider) => { sliderNav = slider; }}
              focusOnSelect
              {...navSettings}
            >
              {data.map(renderSlide)}
            </SlickSlider>
          </NavSliderContainer>
        </Overlay>
      </GalleryContainer>,
      domNode,
    )
  );
};

export default Gallery;
